import CityPageTemplate from "../city-template/CityPageTemplate";
import { oshkoshConfig } from "./data";

export default function OshkoshPage() {
  return <CityPageTemplate config={oshkoshConfig} />;
}